require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/library/fn/array/from.js
// module id = 420
// module chunks = 0